export default __webpack_public_path__ + "static/media/notifications.8109a6c1.png";